export const TRENDING_GAME_KEYS = Object.freeze([
  'heist',
  'glitch',
  'drawback',
  'provenance',
  'sayMore',
])
